import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

/* eslint-disable */
class Portal extends React.Component {

    componentDidMount (){
        this.createContainer();
    }

    componentWillUnmount (){
        this.removeContainer();
    }

    createContainer (){
        this._container = this.props.getContainer();
        this.forceUpdate();
    }

    removeContainer (){
        if (this._container) {
            this._container.parentNode.removeChild(this._container);
        }
    }

    render (){
        const {children} = this.props;
        if (this._container) {
            return ReactDOM.createPortal(children, this._container);
        }
        return null;
    }
}


Portal.protoType = {
    getContainer: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
};

Portal.defaultProps = {
    children: null
};

export default Portal;
